module.exports = __webpack_public_path__ + "img/img_3.16a62cbf.png";